import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_org/org/providers/")({
  beforeLoad: ({ context }) => {
    const organizationBusinessUnitId = (
      context as { savedOrgBusinessUnit?: { id?: string } }
    ).savedOrgBusinessUnit?.id;
    if (!organizationBusinessUnitId) {
      // No org — go to the providers shared with the user (non-org route)
      // without looping.
      throw redirect({ to: "/org/providers/shared" });
    }
    throw redirect({
      to: "/org/bu/$organizationBusinessUnitId/providers/all",
      params: { organizationBusinessUnitId },
    });
  },
});
